import Strings from '../Constants/Strings';


export const goToPage = (history, page) => {
    history.push(`${process.env.PUBLIC_URL}${page}`);
}

export const updateDocumentTitle = title => document.title = title + " | " + Strings.APP_DESCRIPTION;

